import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Product } from '@uc/web/shared/data-models';
import { FeaturedCourseComponent } from '../featured-course/featured-course.component';
import { UniversityCardComponent } from '@web/shared/ui';
import { CourseCardContainerComponent } from '../course-card-container/course-card-container.component';
import { CourseSearchUni, SubjectKeyword } from '../../models/course-search.models';

@Component({
	selector: 'uc-course-list',
	templateUrl: './course-list.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		FeaturedCourseComponent,
		UniversityCardComponent,
		CourseCardContainerComponent,
	],
})
export class CourseListComponent {
	product = input.required<Product>();
	unis = input.required<CourseSearchUni[]>();
	searchTerm = input.required<string>();
	isHECoSSubject = input.required<boolean>();
	degreeLevel = input.required<string>();
	region = input.required<string>();
	subjectKeywords = input<SubjectKeyword[]>();

	trackUni(uniId: number, index: number) {
		return `${uniId}-${index}`;
	}
}
